import React from "react";
import { Link } from "react-router-dom";
import { CONTACT_EMAIL } from "../../../Constants/Home";

// Tarjeta con imagen o emoji, título y texto. Si trae email, agrega el botón de correo; si trae link, un enlace interno
const InfoCard = ({ item, writeUs, style, col = "col-12 col-md-6" }) => {
  return (
    <div className={col}>
      <div className="info-card" data-reveal style={style}>
        <div className="info-card-media" aria-hidden="true">
          {item.image ? <img src={item.image} alt="" /> : <span>{item.icon}</span>}
        </div>
        <div className="info-card-body">
          <h3>{item.title}</h3>
          {item.email && item.text === CONTACT_EMAIL ? (
            <a className="info-card-link" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          ) : (
            <p>{item.text}</p>
          )}
          {item.link && (
            <Link className="info-card-cta" to={item.link.to}>
              {item.link.label} →
            </Link>
          )}
          {item.email && item.text !== CONTACT_EMAIL && (
            <a className="info-card-cta" href={`mailto:${CONTACT_EMAIL}`}>
              {writeUs} · {CONTACT_EMAIL}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default InfoCard;
